<template>
  <div class="page-container">
    <div class="row ml-1">
      <h4 class="mb-4 mr-2">Lista organizacji</h4>
      <div>
        <b-button size="sm" @click="add">
          <span data-feather="plus"></span>
          Dodaj organizacje
        </b-button>
      </div>
    </div>
    <b-table
      :items="items"
      :fields="fields"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      show-empty
      stacked="md"
      :current-page="currentPage"
      :per-page="perPage"
      empty-text="Brak organizacji"
    >
      <template v-slot:cell(actions)="{ item }">
        <b-button-group>
          <b-button class="btn-primary mr-1" size="sm" @click="edit(item)">Edytuj</b-button>
          <b-button class="btn-primary mr-1" size="sm" @click="show(item)">Podgląd</b-button>
          <b-button class="btn-danger mr-1" size="sm" @click="remove(item)">Usuń</b-button>
        </b-button-group>
      </template>
    </b-table>

    <b-row>
      <b-col md="12" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'All',
  mounted() {
    const vm = this
    vm.list()
  },
  data() {
    return {
      items: [],
      fields: [
        { key: 'name', label: 'Nazwa organizacji' },
        { key: 'api_keys', label: 'Klucze API' },
        { key: 'created_at', label: 'Data utworzenia', sortable: true },
        { key: 'updated_at', label: 'Data ostatniej edycji', sortable: true },
        { key: 'actions', label: '' }
      ],
      currentPage: 1,
      totalRows: 0,
      perPage: 6,
      sortBy: '',
      sortDesc: false
    }
  },
  watch: {
    items() {
      this.updateUI()
    }
  },
  methods: {
    list() {
      const vm = this
      vm.$store.commit('addPageLoaderEvent', 'list-visit-type-groups')
      vm.$http
        .post('e-zacma/organization/all')
        .then(response => {
          vm.items = response.data
        })
        .catch(() => {
          vm.$toast.error({
            message: 'Wystapił błąd podczas próby pobrania listy organizacji.'
          })
        })
        .then(() => {
          vm.$store.commit('removePageLoaderEvent', 'list-visit-type-groups')
        })
    },
    edit(item) {
      this.$router.push({ name: 'e-zacma-organization-modify', params: { id: item.id } })
    },
    add() {
      this.$router.push({ name: 'e-zacma-organization-create' })
    },
    show(item) {
      this.$router.push({ name: 'e-zacma-organization-view', params: { id: item.id } })
    },
    remove(item) {
      const vm = this
      vm.$bvModal
        .msgBoxConfirm(`Czy napewno chcesz skasować organizacje o nazwie "${item.name}"?`, {
          okVariant: 'danger',
          okTitle: 'Tak',
          cancelTitle: 'Nie',
          hideHeaderClose: false,
          centered: true
        })
        .then(decision => {
          if (decision) {
            vm.$store.commit('addPageLoaderEvent', 'delete-organization')
            vm.$http
              .post('e-zacma/organization/delete', { id: item.id })
              .then(() => {
                vm.list()
                vm.$toast.success({
                  message: `Organizacja o nazwie "${item.name}" została skasowana.`
                })
              })
              .catch(e => vm.$error())
              .finally(() => {
                vm.$store.commit('removePageLoaderEvent', 'delete-organization')
              })
          }
        })
    },
    updateUI() {
      this.totalRows = this.items.length
    }
  }
}
</script>

<style scoped></style>
